import { render, staticRenderFns } from "./SearchWrap.vue?vue&type=template&id=389c0c3c&scoped=true&"
import script from "./SearchWrap.vue?vue&type=script&lang=js&"
export * from "./SearchWrap.vue?vue&type=script&lang=js&"
import style0 from "./SearchWrap.vue?vue&type=style&index=0&id=389c0c3c&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389c0c3c",
  null
  
)

export default component.exports